/**
 * plugins/details.ts — Acordeão (details/summary)
 */

import { VtbPlugin, IVtbRegistry, SmartCtx, closestInside } from '../types';

export class DetailsPlugin implements VtbPlugin {
    readonly panelId = 'vtb-details';
    readonly selectorHints = ['details', '[data-vtb-id="details"]'];

    detect(target: HTMLElement, visualEditor: HTMLElement): SmartCtx | null {
        const el = closestInside(target, visualEditor, e => 
            e.tagName === 'DETAILS' || e.dataset.vtbId === 'details'
        );
        if (!el) return null;
        return { type: this.panelId, label: 'Acordeão', el };
    }

    activate(ctx: SmartCtx, registry: IVtbRegistry): void {
        const summary = ctx.el.querySelector('summary');
        const input = registry.q<HTMLInputElement>('vtb-details-title');
        if (input) input.value = summary?.textContent?.trim() ?? '';
    }

    setup(registry: IVtbRegistry): void {
        registry.q('vtb-details-apply')?.addEventListener('click', () => this._apply(registry));
        registry.q('vtb-details-toggle')?.addEventListener('click', () => this._toggle(registry));
    }

    private _apply(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx;
        if (!ctx) return;

        const title = registry.q<HTMLInputElement>('vtb-details-title')?.value?.trim() ?? 'Clique para ver mais';
        let summary = ctx.el.querySelector('summary');
        if (!summary) {
            summary = document.createElement('summary');
            summary.style.cursor = 'pointer';
            summary.style.fontWeight = 'bold';
            summary.style.marginBottom = '8px';
            ctx.el.prepend(summary);
        }
        summary.textContent = title;
        registry.sync();
    }

    private _toggle(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx as { el: HTMLDetailsElement } | null;
        if (!ctx) return;
        ctx.el.open = !ctx.el.open;
        registry.sync();
    }
}
